export const OPEN_PROJECT_EVENT = "open-portfolio-project";

export type OpenProjectDetail = {
  id: string;
};

export function openPortfolioProject(id: string): void {
  window.dispatchEvent(
    new CustomEvent<OpenProjectDetail>(OPEN_PROJECT_EVENT, { detail: { id } }),
  );
  const hash = `#project-${id}`;
  if (window.location.hash !== hash) {
    window.history.replaceState(null, "", hash);
  }
}

export function projectIdFromHash(hash: string): string | null {
  const match = hash.match(/^#project-([a-z0-9-]+)$/i);
  return match?.[1] ?? null;
}
